import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash/isEqual';
import styles from './preloader.module.scss';
import BackgroundImage from '../BackgroundImage';
import Button from '../Button';
import Lottie from '../Lottie';

class PreloaderContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      percentage: 0,
      accept: false,
      isIosOrAndroid: this.props.device === 'ios' || this.props.device === 'android',
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.percentage, state.percentage)) {
      return {
        percentage: props.percentage,
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.device !== this.props.device || nextState.percentage !== this.state.percentage || nextState.accept !== this.state.accept;
  }

  componentWillUnmount() {
    this.setState({
      percentage: 0,
      accept: false,
    })
  }

  render() {
    const imgCssClass = [styles.img];
    const preloaderCssClass = [styles.preloader];

    if (this.state.percentage === 100) {
      imgCssClass.push(styles.loaded);
      if (this.state.isIosOrAndroid && this.state.accept) {
        preloaderCssClass.push(styles.loaded);
      } else if (!this.state.isIosOrAndroid) {
        preloaderCssClass.push(styles.loaded);
      }
    }
    return (
      <div className={preloaderCssClass.join(' ')}>
        <div className={styles.inner}>
          <header className={styles.header}>
            <Lottie icon={'logo-white'} autoplay loop />
          </header>
          <span className={styles.track}>
            <span className={styles.progress} style={{'width': `${this.state.percentage}%`}}></span>
          </span>
          <h3 className={styles.load}>{`Indlæser ${this.state.percentage} / 100`}</h3>
          {this.state.isIosOrAndroid &&
            <article className={styles.warn}>
              <p>{`Over Murens cases fungerer bedst på en almindelig computerskærm.`}</p>
              <Button regular onClick={() => this.setState({ accept: true })}>{`Se alligevel`}</Button>
            </article>
          }
        </div>
        <img className={imgCssClass.join(' ')} src="/wall.jpg" />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    device: state.context.device,
    viewport: state.context.viewport,
  }
}

const mapDispatchToProps = (dispatch) => {
  return { }
}

const Preloader = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PreloaderContainer);

export default Preloader;



// WEBPACK FOOTER //
// ./src/components/Preloader/index.jsx